"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationArrowRight = void 0;
var React = require("react");
var NavigationArrowRight = function () { return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16", fill: "none" },
    React.createElement("path", { d: "M9.27876 1.79395L14.7071 7.22229C15.0976 7.61281 15.0976 8.24598 14.7071 8.6365L9.36495 13.9787L8.65784 13.2716L13.4293 8.50008H0.972168V7.50008H13.5707L8.57165 2.50105L9.27876 1.79395Z", fill: "#666666" }))); };
exports.NavigationArrowRight = NavigationArrowRight;
//# sourceMappingURL=NavigationArrowRight.js.map